import { Box, styled } from "@mui/material";

export const PackageGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: center;
  padding-top: 50px;
  gap: 20px;
`;
